// extracted by mini-css-extract-plugin
module.exports = {"pagination__item":"pagination__item-wRk_y","pagination__itemActive":"pagination__itemActive-2Q0Dd"};